import {UPDATE_CACHED_MEDIA_LIST} from '~/common/reducers/cachedMedia/constants';

interface MediaEntry {
  id: string;
  media: string;
}

interface State {
  [storeName: string]: MediaEntry[];
}

interface UpdateCachedMediaListPayload {
  storeName: string;
  entries: MediaEntry[];
}

type Action = {type: typeof UPDATE_CACHED_MEDIA_LIST; payload: UpdateCachedMediaListPayload};

const initialState: State = {};

// eslint-disable-next-line default-param-last
export const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case UPDATE_CACHED_MEDIA_LIST: {
      const {storeName, entries} = action.payload as UpdateCachedMediaListPayload;

      // If there are no entries at all, clear out this storeName key.
      if (entries.length === 0) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const {[storeName]: _, ...rest} = state;
        return rest;
      }
      return {
        ...state,
        [storeName]: entries,
      };
    }
    default:
      return state;
  }
};
